/**
 * Card portrait URL for orders/units (matches OrderDesign: explicit `image` wins).
 * Explore Unknown synthetic units set `image` to paths that do not follow `/images/<id>.jpg`.
 */

import {
  resolveAlternateArtImageSrc,
  resolveArtVariantImageSrc,
  getOrderArtVariant,
  withAlternateArtDisplayOrder,
} from './alternateArtDisplay.js';

/**
 * @param {{ id?: unknown, image?: unknown, useAlternateArt?: unknown } | null | undefined} orderLike
 * @returns {string}
 */
export function getOrderCardImageSrc(orderLike) {
  if (orderLike?.image && typeof orderLike.image === 'string' && orderLike?.useAlternateArt === true) {
    return orderLike.image;
  }
  if (orderLike?.useAlternateArt === true && orderLike?.id != null) {
    const variant = orderLike.alternateArtVariant != null
      ? Number(orderLike.alternateArtVariant)
      : getOrderArtVariant(orderLike.id);
    const fromVariant = resolveArtVariantImageSrc(orderLike.id, variant);
    if (fromVariant) return fromVariant;
    return `/images/a${orderLike.id}.jpg`;
  }
  if (orderLike?.image && typeof orderLike.image === 'string') {
    return orderLike.image;
  }
  const altFromPrefs = orderLike?.id != null ? resolveAlternateArtImageSrc(orderLike.id) : null;
  if (altFromPrefs) {
    return altFromPrefs;
  }
  return `/images/${orderLike.id}.jpg`;
}

/**
 * Fields copied into client-detected action history entries so thumbnails match battlefield cards.
 * @param {{ id?: unknown, name?: unknown, instanceId?: unknown, image?: unknown, useAlternateArt?: unknown } | null | undefined} orderLike
 * @returns {{ id: unknown, name: unknown, instanceId: unknown, image?: string, useAlternateArt?: boolean }}
 */
export function pickOrderLogCardFields(orderLike) {
  if (!orderLike || typeof orderLike !== 'object') {
    throw new Error('pickOrderLogCardFields: orderLike must be a non-null object');
  }
  const display = withAlternateArtDisplayOrder(orderLike);
  const out = {
    id: display.id,
    name: display.name,
    instanceId: display.instanceId,
  };
  if (display.image && typeof display.image === 'string') {
    out.image = display.image;
  }
  if (display.useAlternateArt === true) {
    out.useAlternateArt = true;
  }
  return out;
}
